<template>
  <div v-if="look.mode == 'explore'" class="chat-look">
    <div v-for="(entry, idx) in refToReloadPicture" :key="idx" class="chat-look-top">
      <img :src="entry" alt=" product " />
    </div>
    <my-carousel
      v-if="look.values.down"
      class="chat-look-bottom"
      :carousel="look.values.down"
    ></my-carousel>
  </div>
</template>

<script>
import { apiRequest } from "@/services/api";
import MyCarousel from "./MyCarousel";

export default {
  name: "Look",
  components: {
    MyCarousel,
  },
  props: ["look"],
  data() {
    return {
      top: null,
      refToReloadPicture: [],
      down: [],
    };
  },
  async mounted() {
    // if (this.look.already_explored) {
    //   this.getProductsById(this.look.already_explored);
    // } else if (this.look.mode == "explore") {
    //   const res = await this.look.values;

    //   if (res && res.product_ids.length > 0) this.getProductsById(res);
    // }
    this.refToReloadPicture = this.look.values.picture_url
    this.down = this.look.values.down
  },
  methods: {
    // getProductsById(res) {
    //   if (res != null) {
    //     this.top = res.picture_url;
    //     apiRequest()
    //       .get("products/list/" + res.product_ids.join(","))
    //       .then((done) => {
    //         if (done && done.data && done.data.products) {
    //           this.down = {
    //             type: "products",
    //             values: done.data.products,
    //           };
    //         }
    //       });
    //   }
    // },
  },
};
</script>
